import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useDataTableContext } from "@msuite/ui/table";
import { Fragment } from "react";
import { Can } from "@/components/citadel/can";
import { AddTransferCarrierModal } from "@/modals/stock/add-transfer-carrier-modal";

export function TransferCarriersMenu() {
	/** Context */
	const { refetch } = useDataTableContext();

	/** Hooks */
	const { t } = useTranslation();
	const addModal = useDisclosure();

	/** Render */
	return (
		<Fragment>
			<Can
				action="create"
				subject="Stock"
			>
				<Button
					onClick={addModal.onOpen}
					variant="primary"
					icon={<Icon name="Plus" />}
					data-cy="add-transfer-carrier-button"
				>
					{t("stock.add_transfer_carrier")}
				</Button>
			</Can>
			{addModal.isOpen && (
				<AddTransferCarrierModal
					isOpen={addModal.isOpen}
					onClose={addModal.onClose}
					onComplete={refetch}
				/>
			)}
		</Fragment>
	);
}
